import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import SubCategoryTable from "../../elements/Tables/SubCategoryTable/SubCategoryTable";
import SubCategoryCreationForm from "../../elements/Forms/SubCategoryCreationForm/SubCategoryCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_SUBCATEGORY_API,
  FETCH_ALL_CATEGORY_API,
} from "../../../Constants/Apis";
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteSubCategory } from "../../../Services/SubCategoryService";

const { Search } = Input;

const SubCategoryPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subcategoryId, setSubCategoryId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setSubCategoryId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteSubCategory(subcategoryId);
      message.success("SubCategory deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete subcategory."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_SUBCATEGORY_API}`, state);

    const {
      fetchedData: { data : categoryData },
      callReFetchCategory,
      loadingCategory,
    } = useFetch(`${FETCH_ALL_CATEGORY_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New SubCategory
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <SubCategoryTable
        history={history}
        loading={loading}
        data={data}
        userData={userData}

        categoryData={categoryData}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create SubCategory"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <SubCategoryCreationForm
          history={history}
          userData={userData}
          categoryData={categoryData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete SubCategory"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this subcategory?</p>
      </Modal>
    </div>
  );
};

SubCategoryPage.propTypes = {};

export default SubCategoryPage;
